export enum SpecialSymbolType {
    MULTIPLIER = 28010,
    SCATTER = 28011,
}
